"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const _ = require("lodash");
const baseURL = "/v2/user";
class User {
    static find(params = {}) {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        return new Promise((resolve, reject) => {
            http
                .get(`${baseURL}?${$.param(params)}`)
                .toPromise()
                .then(response => response.json())
                .then(response => {
                let users = response.map(user => new User(user));
                resolve(users);
            })
                .catch(err => {
                let res = err.json();
                reject(res);
            });
        });
    }
    constructor(params = {}) {
        Object.assign(this, params);
        this.orgName = _.get(this, "organization.displayName");
        if (this.roles)
            this.concatRoles = this.roles.map(role => role.displayName).join(", ");
    }
    managedOrganizationCount() {
        return this.managedOrganizations.length;
    }
    create() {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        return new Promise((resolve, reject) => {
            http
                .post(`${baseURL}`, this.params())
                .toPromise()
                .then(response => response.json())
                .then(response => {
                let user = new User(response);
                resolve(user);
            })
                .catch(err => {
                let res = err.json();
                reject(res);
            });
        });
    }
    update() {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        return new Promise((resolve, reject) => {
            http
                .put(`${baseURL}/${this.id}`, this.params())
                .toPromise()
                .then(response => response.json())
                .then(response => {
                let user = new User(response);
                Object.assign(this, user);
                resolve(user);
            })
                .catch(err => {
                let res = err.json();
                reject(res);
            });
        });
    }
    params() {
        return _.pick(this, [
            "email",
            "password",
            "confirmPassword",
            "organization",
            "roles",
            "deleted",
            "sendEmail",
        ]);
    }
    validate(options = {
        email: true,
        password: true,
        roles: false
    }) {
        let errors = [];
        if (options.password !== false && this.password !== this.confirmPassword) {
            errors.push("Password entered does not match confirm password");
        }
        if (options.email !== false &&
            !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$/i.test(this.email)) {
            errors.push("Email is invalid");
        }
        if (options.password !== false) {
            let validPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!.%*?&])[A-Za-z\d$@.$!%*?&]{8,}/;
            if (validPassword.test(this.password) == false) {
                errors.push("Password does not meet minimum criteria");
            }
        }
        if ((options.roles && options.roles == true) && (!this.roles || !this.roles.length || this.roles.length == 0)) {
            errors.push("Missing Role Assignments");
        }
        return errors;
    }
    generatePassword() {
        var lettersLC = [
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
        ];
        var lettersUC = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
        ];
        var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        var symbols = ["!", "@", "$", "%", "&", "*"];
        var randomstring = [];
        for (var i = 0; i < 5; i++) {
            var rletLC = Math.floor(Math.random() * lettersLC.length);
            randomstring.push(lettersLC[rletLC]);
        }
        for (var i = 0; i < 3; i++) {
            var rnum = Math.floor(Math.random() * numbers.length);
            randomstring.push(numbers[rnum]);
        }
        for (var i = 0; i < 3; i++) {
            var rsym = Math.floor(Math.random() * symbols.length);
            randomstring.push(symbols[rsym]);
        }
        for (var i = 0; i < 3; i++) {
            var rletUC = Math.floor(Math.random() * lettersUC.length);
            randomstring.push(lettersUC[rletUC]);
        }
        for (var i = randomstring.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = randomstring[i];
            randomstring[i] = randomstring[j];
            randomstring[j] = temp;
        }
        let password = randomstring.join("");
        this.password = password;
        this.confirmPassword = password;
    }
    convertRolesToIds() {
        this.roles = [
            ...this.roles.map(role => {
                if (typeof role !== "number") {
                    role = role.id;
                }
                return role;
            }),
        ];
    }
}
exports.User = User;
//# sourceMappingURL=user.js.map